import { socketClient } from 'pages/views/devices/socketClient';
import { CFD_MESSAGES } from 'pages/views/devices/socketClient/types';
import { hasFeature } from 'root/api/admin/features';

import { getCFDEnabled } from './get-cfd-enabled';
import {
  transformPayload,
  transformToLSPayCFDSaleCompleted,
  transformToLSPayCFDSaleUpdated,
} from './sale-transformer';
import { getHubEnabled } from './storage';

function buildRSeriesPayload(sale: Sale, isCompleted: boolean) {
  const payload = transformPayload(sale);

  if (isCompleted) {
    return {
      sale: {
        saleID: payload.saleID,
        paymentType: payload.paymentType,
        change: payload.change,
        calcTotal: payload.calcTotal,
        calcDiscount: payload.calcDiscount,
        completed: true,
      },
    };
  }

  return { sale: payload };
}

export function handleCFDSaleUpdate(sale: Sale) {
  const isCompleted = sale?.completed === true;
  const event = isCompleted ? CFD_MESSAGES.COMPLETE_SALE : CFD_MESSAGES.UPDATE_SALE;

  hasFeature('PaymentsTerminalCustomerFacingDisplay')
    .then((isLSPayCFD) => {
      if (isLSPayCFD) {
        // LSPay CFD - no Hub/CFD checks needed
        const lsPayPayload = isCompleted
          ? transformToLSPayCFDSaleCompleted(sale)
          : transformToLSPayCFDSaleUpdated(sale);
        socketClient.send(event as CFD_MESSAGES.UPDATE_SALE, lsPayPayload as any);
      } else {
        // R-Series - requires Hub/CFD to be enabled
        if (!getHubEnabled() || !getCFDEnabled()) return;
        socketClient.send(
          event as CFD_MESSAGES.UPDATE_SALE,
          buildRSeriesPayload(sale, isCompleted)
        );
      }
    })
    .catch(() => {
      // Fallback to R-Series format on error - only send if Hub/CFD enabled
      if (!getHubEnabled() || !getCFDEnabled()) return;
      socketClient.send(event as CFD_MESSAGES.UPDATE_SALE, buildRSeriesPayload(sale, isCompleted));
    });
}
